<template>
  <v-row class="ma-0">
   <v-col
      cols="3"
      class="pa-0"
    
    >
      <v-tooltip bottom v-if="params.data?.sub_hire_id"> 
        <template #activator="{ on, attrs }">
          <v-icon
            class="mr-4 ml-1"
            color="info"
            v-on="on"
            v-bind="attrs"
            @click="fullDebitNotes()"
          >
            mdi-file-compare
          </v-icon>
        </template>
        <span>Full Debit Note</span>
      </v-tooltip>
   </v-col>

      <v-col
      cols="3"
      class="pa-0"
    
    >
      <v-tooltip bottom v-if="!params.data?.sub_hire_id" >
        <template #activator="{ on, attrs }">
          <v-icon
            class="mr-4 ml-1"
            color="info"
            v-on="on"
            v-bind="attrs"
            @click="partialDebitNotes()"
          >
            mdi-file-compare
          </v-icon>
        </template>
        <span>Partial Debit Note</span>
      </v-tooltip>
   </v-col>
  </v-row>
</template>

<script>
export default {
  methods: {
    fullDebitNotes() {
      this.params.context.parentComponent.fullDebitNote(this.params.data);
    },
     partialDebitNotes() {
   
      this.params.context.parentComponent.partialDebitNote(this.params.data);
    },
  },
};
</script>

<style scoped>
.v-btn {
  width: 100%;
  border-radius: 8px;
}
</style>
